enum ACTIONS {
    FETCH_ALL_VACANCIES = 'FETCH_ALL_VACANCIES_V2',

    CREATE_OFFER = '[OFFER] - CREATE',
    CREATE_OFFER_VALUES = '[OFFER] - CREATE VALUES',
    BACKGROUND_CREATE_OFFER_VALUES = '[OFFER][BACKGROUND] CREATE VALUES',

    FETCH_ALL_OFFERS = 'FETCH_ALL_OFFERS_V2',
    FETCH_OFFER = 'FETCH_OFFER_V2',
    FETCH_OFFER_VALUES = 'FETCH_OFFER_VALUES',
    FETCH_VACANCIES_VALUES = 'FETCH_OFFERS_VALUES',
    FETCH_OFFER_CONCEPT = 'FETCH_OFFER_CONCEPT',
    FETCH_OFFER_OVERVIEW_PAGE = '[OFFER] Overview page',

    
    UPDATE_OFFER = '[OFFER] UPDATE',
    UPDATE_OFFER_VALUES = '[OFFER] UPDATE VALUES',
    BACKGROUND_UPDATE_OFFER_VALUES = '[OFFER][BACKGROUND] UPDATE VALUES',
    UPSERT_OFFER_VALUES = '[OFFER] UPSERT VALUES',
    SAVE_OFFER_VALUES = 'SAVE_OFFER_VALUES',

    DELETE_OFFER = '[OFFER] - DELETE'
}

export default ACTIONS;